import { useEffect, useState } from "react";
import { LayoutList } from "lucide-react";
import { api, photoUrl } from "../../lib/api";
import { Switch } from "../../components/ui/switch";
import { CATEGORIES } from "../../lib/constants";

const BLOCK_CATS = ["dogs", "cats", "birds", "reptiles", "aquatics", "small-pets", "livestock", "rescue", "supplies-services"];
const COUNTS = [3, 4, 6, 8, 10, 12];
const label = (id) => CATEGORIES.find((c) => c.id === id)?.label || id;

const Preview = ({ f }) => {
  const [items, setItems] = useState(null);
  const key = `${f.listings_count}|${f.listings_categories.join(",")}`;
  useEffect(() => {
    const t = setTimeout(() => {
      api.post("/admin/newsletter/listings-preview", { subject: "x", message: "x", listings_count: f.listings_count, listings_categories: f.listings_categories })
        .then((r) => setItems(r.data.items)).catch(() => setItems([]));
    }, 300);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items) return null;
  if (!items.length) return <p className="text-xs text-amber-700 mt-2" data-testid="nl-listings-none">No active listings in these categories right now — the box is left out when there's nothing to show.</p>;
  return (
    <div className="mt-3" data-testid="nl-listings-preview">
      <p className="text-[11px] text-slate-500 mb-1.5">If it went out now, it would show ({items.length}):</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {items.map((x) => (
          <div key={x.id} className="flex items-center gap-2 rounded-lg bg-slate-50 p-1.5" data-testid={`nl-listings-item-${x.id}`}>
            {x.photos?.[0] ? <img src={photoUrl(x.photos[0])} alt="" className="h-9 w-12 rounded object-cover shrink-0" /> : <div className="h-9 w-12 rounded bg-slate-200 shrink-0" />}
            <span className="text-xs text-[#12234A] font-medium line-clamp-2">{x.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export function ListingsBlockControl({ f, set }) {
  const cats = f.listings_categories;
  const toggleCat = (id) => set("listings_categories", cats.includes(id) ? cats.filter((c) => c !== id) : [...cats, id]);
  return (
    <div className="mt-4 rounded-xl border border-slate-200 p-3" data-testid="nl-listings">
      <label className="flex items-center gap-2 text-sm font-semibold text-[#12234A] cursor-pointer">
        <Switch checked={f.listings_enabled} onCheckedChange={(v) => set("listings_enabled", v)} data-testid="nl-listings-toggle" />
        <LayoutList size={15} className="text-[#F5551E]" /> Add a box of the newest listings
      </label>
      <p className="text-xs text-slate-500 mt-1">Filled in automatically at the moment it sends (scheduled newsletters too), below your message and button.</p>
      {f.listings_enabled && (
        <div className="mt-3 space-y-3">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs font-semibold text-slate-600 mr-1">How many</span>
            {COUNTS.map((n) => (
              <button key={n} type="button" onClick={() => set("listings_count", n)} data-testid={`nl-listings-count-${n}`}
                className={`h-8 w-9 rounded-lg text-sm font-semibold transition-colors ${f.listings_count === n ? "bg-[#12234A] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{n}</button>
            ))}
          </div>
          <div>
            <span className="text-xs font-semibold text-slate-600">Categories <span className="font-normal text-slate-400">— none ticked = all of them</span></span>
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {BLOCK_CATS.map((id) => (
                <button key={id} type="button" onClick={() => toggleCat(id)} data-testid={`nl-listings-cat-${id}`}
                  className={`px-2.5 h-7 rounded-full text-xs font-semibold border transition-colors ${cats.includes(id) ? "bg-[#F5551E] border-[#F5551E] text-white" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>{label(id)}</button>
              ))}
            </div>
          </div>
          <Preview f={f} />
        </div>
      )}
    </div>
  );
}
